export const clearFields = ($container) => {
    $container.find('select').val('');
    $container.find('input[type="text"]').val('');
    $container.find('input[type="number"]').val('');
    $container.find('input[type="checkbox"]').attr('checked', false);
}

export const hasValidFields = ($container) => {
    let isValid = true
    $container.find("input, select, textarea").each(function() {
        const $input = $(this);
        if (!$input.valid()) isValid = false;
    });
    return isValid;
}

export const copyAddress = ($sourceFields, $targetFields) => {

        const inputSelectors = [
            ".first-name input",
            ".last-name input",
            ".email input",
            ".address input",
            ".address2 input",
            ".city input",
            ".state select",
            ".zip input"
        ];

        inputSelectors.forEach(fieldClass => {
            const $sourceInput = $sourceFields.find(fieldClass);
            const $targetInput = $targetFields.find(fieldClass);
            try {
                $targetInput.val($sourceInput.val()).valid();
            } catch (e) {
                console.log(e);
            }
        });
    }